
// this file generated by NC command
const NC_CONFIG = {
  dataset: "CRLT_People",
  port: "3000",
  googlea: "0"
};
if (typeof process === "object") module.exports = NC_CONFIG;
if (typeof window === "object") window.NC_CONFIG = NC_CONFIG;
